import { render } from "./reserve.vue?vue&type=template&id=521e1deb&scoped=true"
import script from "./reserve.vue?vue&type=script&lang=js"
export * from "./reserve.vue?vue&type=script&lang=js"

import "./reserve.vue?vue&type=style&index=0&id=521e1deb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521e1deb"]])

export default __exports__